<!-- obavjestenja.component.html -->
<div class="grid-section">
  <div *ngIf="isUserAgroModerator()" class="toolbar">
    <dx-button
      icon="plus"
      text="Dodaj novo"
      type="default"
      (onClick)="onAddClick()">
    </dx-button>
    
    <dx-button
      icon="edit"
      text="Izmijeni"
      type="default"
      [disabled]="!selectedObavjestenje"
      (onClick)="onEditClick()">
    </dx-button>
    
    <dx-button
      icon="trash"
      text="Obriši"
      type="danger"
      [disabled]="!selectedObavjestenje"
      (onClick)="onDeleteClick()">
    </dx-button>
    
    <dx-button
      icon="refresh"
      text="Osvježi"
      type="default"
      (onClick)="onRefreshClick()">
    </dx-button>
  </div>

  <dx-data-grid
    #obavjestenjaGrid
    id="obavjestenjaGrid"
    keyExpr="id"
    [dataSource]="gridData"
    [showBorders]="true"
    [allowColumnResizing]="true"
    [showColumnLines]="true"
    [showRowLines]="true"
    [hoverStateEnabled]="true"
    [filterRow]="{ visible: true }"
    [searchPanel]="{ visible: true }"
    [paging]="{ pageSize: 50 }"
    [pager]="{
      showPageSizeSelector: true,
      allowedPageSizes: [10, 20, 50, 100],
      showInfo: true
    }"
    [selection]="{ mode: 'single' }"
    [rowAlternationEnabled]="true"
    (onRowClick)="onObavjestenjeRowClick($event)">
    
    <dxi-column 
      dataField="tekst" 
      caption="Obavještenje" 
      [minWidth]="300"
      [allowFiltering]="true"
      [allowSearch]="true">
    </dxi-column>
    
    <dxo-scrolling mode="virtual"></dxo-scrolling>
    <dxo-sorting mode="multiple"></dxo-sorting>
  </dx-data-grid>
</div>

<!-- Create Popup -->
<dx-popup
  [width]="600"
  [height]="400"
  [showTitle]="true"
  title="Dodaj Novo Obavještenje"
  [(visible)]="isCreatePopupVisible"
  (onHiding)="onCreatePopupHidden()">
  
  <div *dxTemplate="let data of 'content'">
    <form [formGroup]="obavjestenjeForm">
      <div class="form-fields">
        <dx-text-area
          formControlName="tekst"
          placeholder="Unesite tekst obavještenja"
          [height]="200"
          [isValid]="!obavjestenjeForm.get('tekst')?.errors"
          validationMessage="Tekst obavještenja je obavezan">
        </dx-text-area>
      </div>
      
      <div class="popup-buttons">
        <dx-button
          text="Kreiraj"
          type="default"
          (onClick)="createObavjestenje()"
          [disabled]="!obavjestenjeForm.valid || loading">
        </dx-button>
        
        <dx-button
          text="Otkaži"
          (onClick)="isCreatePopupVisible = false">
        </dx-button>
      </div>
    </form>
  </div>
</dx-popup>

<!-- Edit Popup -->
<dx-popup
  [width]="600"
  [height]="400"
  [showTitle]="true"
  title="Izmijeni Obavještenje"
  [(visible)]="isEditPopupVisible"
  (onHiding)="onEditPopupHidden()">
  
  <div *dxTemplate="let data of 'content'">
    <form [formGroup]="obavjestenjeForm">
      <div class="form-fields">
        <dx-text-area
          formControlName="tekst"
          placeholder="Unesite tekst obavještenja"
          [height]="200"
          [isValid]="!obavjestenjeForm.get('tekst')?.errors"
          validationMessage="Tekst obavještenja je obavezan">
        </dx-text-area>
      </div>
      
      <div class="popup-buttons">
        <dx-button
          text="Ažuriraj"
          type="default"
          (onClick)="updateObavjestenje()"
          [disabled]="!obavjestenjeForm.valid || loading">
        </dx-button>
        
        <dx-button
          text="Otkaži"
          (onClick)="isEditPopupVisible = false">
        </dx-button>
      </div>
    </form>
  </div>
</dx-popup>

<dx-load-panel
  [position]="loadPanelPosition"
  [visible]="loading"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.4)">
</dx-load-panel>